import { createSlice } from "@reduxjs/toolkit";

const scholarshipSlice = createSlice({
  name: "Scholarship",
  initialState: {
    Scholarship: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    addScholarshipStart(state) {
      state.Scholarship.loading = true;
      state.Scholarship.error = null;
    },
    addScholarshipSuccess(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.data = action.payload;
    },
    addScholarshipFailure(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.error = action.payload;
    },
    updateScholarshipStart(state) {
      state.Scholarship.loading = true;
      state.Scholarship.error = null;
    },
    updateScholarshipSuccess(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.data = action.payload;
    },
    updateScholarshipFailure(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.error = action.payload;
    },
    fetchScholarshipStart(state) {
      state.Scholarship.loading = true;
      state.Scholarship.error = null;
    },
    fetchScholarshipSuccess(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.data = action.payload;
    },
    fetchScholarshipFailure(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.error = action.payload;
    },
    deleteScholarshipStart(state) {
      state.Scholarship.loading = true;
      state.Scholarship.error = null;
    },
    deleteScholarshipSuccess(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.data = state.Scholarship.data.filter(
        (item) => item.id !== action.payload
      );
    },
    deleteScholarshipFailure(state, action) {
      state.Scholarship.loading = false;
      state.Scholarship.error = action.payload;
    },
  },
});
export const {
  addScholarshipStart,
  addScholarshipSuccess,
  addScholarshipFailure,
  updateScholarshipStart,
  updateScholarshipSuccess,
  updateScholarshipFailure,
  fetchScholarshipStart,
  fetchScholarshipSuccess,
  fetchScholarshipFailure,
  deleteScholarshipStart,
  deleteScholarshipSuccess,
  deleteScholarshipFailure,
} = scholarshipSlice.actions;

export default scholarshipSlice.reducer;
